module.exports = __webpack_public_path__ + "img/c5201704-4.ea19b385.jpg";